import { SessionScreen, type SessionNotice } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';

export type SessionStage = 'session' | 'signIn' | 'workspace';

const STAGE_MESSAGE_KEYS = {
  session: 'shell.checkingSession',
  signIn: 'shell.loggingIn',
  workspace: 'shell.openingWorkspace',
} as const satisfies Record<SessionStage, string>;

export const SessionProgress = ({
  stage,
  notice,
}: {
  stage: SessionStage;
  notice?: SessionNotice | undefined;
}) => {
  const { t } = useTranslation();
  return (
    <SessionScreen
      appName={t('shell.appName')}
      message={t(STAGE_MESSAGE_KEYS[stage])}
      steps={[
        { id: 'session', label: t('shell.stepSession') },
        { id: 'signIn', label: t('shell.stepSignIn') },
        { id: 'workspace', label: t('shell.stepWorkspace') },
      ]}
      currentStep={stage}
      progressLabel={t('shell.loading')}
      footnote={t('shell.secureSignIn')}
      notice={notice}
    />
  );
};
